// @ts-check
import { useNavigate } from "react-router-dom";

import "./Listado.scss";

import more from "../assets/more_vert-black-18dp.svg";
import cerrar from "../assets/close-24px.svg";
import AppDevice from "../../../Class/device";
import {
  BookUser,
  CircleUserRound,
  CloudDownload,
  Loader2,
  Paperclip,
  Share2,
  ServerCrash,
  SearchX,
} from "lucide-react";
import StudyForList from "../../../models/studies/list";
import { Appsettings } from "../../../Appsettings";
import { useMainContext } from "../MainContext";

/**
 * @returns {JSX.Element}
 */
function Listado() {
  const { state } = useMainContext();
  const ListaEstudios = state.estudios;
  const FiltroPaciente = state.filtros.paciente;
  const filtromod = state.filtros.mod;
  const VerHerramientas = state.ui.herramientas;

  let array = ListaEstudios.items;
  if (ListaEstudios.cargando) {
    return (
      <div id="Listado">
        <Cargando />
      </div>
    );
  }
  if (ListaEstudios.error) {
    return (
      <div id="Listado">
        <ErrorServidor />
      </div>
    );
  }
  let items = [];
  for (let index = 0; index < array.length; index++) {
    const element = array[index];
    if (element.filtrar(FiltroPaciente) && element.filtrarmod(filtromod)) {
      items.push(
        <Item
          key={index}
          herramientas={element.id === VerHerramientas?.id}
          estudio={element}
        />,
      );
    }
  }

  if (items.length === 0) {
    return (
      <div id="Listado">
        <SinResultados />
      </div>
    );
  }

  return <div id="Listado">{items}</div>;
}

export default Listado;
///////////////////////////////////////

/**
 * @param {Object} props
 * @param {boolean} props.herramientas
 * @param {StudyForList} props.estudio
 * @returns {JSX.Element}
 */
const Item = (props) => {
  let clase = props.herramientas ? "Item activo" : "Item";
  return (
    <div className={clase}>
      <div className="DatosEstudio">
        <DatosEstudio estudio={props.estudio} />
      </div>
      <div className="Herramientas">
        <Herramientas estudio={props.estudio} />
      </div>
    </div>
  );
};

/**
 * @param {Object} props
 * @param {StudyForList} props.estudio
 * @returns {JSX.Element}
 */
const DatosEstudio = (props) => {
  const { dispatch } = useMainContext();
  const study = props.estudio;
  let inform = "Inform";
  if (study.informs.length > 0) {
    inform = "Inform Exist";
  }
  let abrirherramientas = () => {
    dispatch({ type: "SET_HERRAMIENTAS", payload: props.estudio });
  };
  const navigate = useNavigate();
  let verestudio = () => {
    navigate(`/visor/${study.id}`);
  };
  return (
    <div className="DatosEstudio1">
      <div className={inform}></div>
      <div className="DatosEstudio11">
        <CircleUserRound color={study.sexColor()} size={60} />
      </div>
      <div className="DatosEstudio12" onClick={verestudio}>
        <div className="DatosEstudio121">
          {`${study.getPatientName()} - (${study.getPatientId()})`}
        </div>
        <div className="DatosEstudio122">{study.getModalityText()}</div>
        <div className="DatosEstudio123">{study.getStudyDate()}</div>
      </div>
      <div className="DatosEstudio13" onClick={abrirherramientas}>
        <img src={more} alt="" width="40px" />
      </div>
    </div>
  );
};

/**
 * @param {Object} props
 * @param {StudyForList} props.estudio
 * @returns {JSX.Element}
 */
const Herramientas = (props) => {
  const { dispatch } = useMainContext();
  const study = props.estudio;

  let cerrarherramientas = () => {
    dispatch({ type: "SET_HERRAMIENTAS", payload: null });
  };

  /**
   * @param {number} e
   */
  let abrirDialog = (e) => {
    dispatch({ type: "SET_DIALOG", payload: { visible: true, componente: e } });
  };
  let DownloadStudy = () => {
    const url = AppDevice.Cloud
      ? `${AppDevice.ServerUrl}/cloud/zipstudy/${AppDevice.Cloud}/${study.getUuid()}`
      : `${Appsettings.ApiUrl}/DescargaEstudio/${study.getUuid()}`;
    window.open(url, "_blank");
  };
  return (
    <div className="Herramientas1">
      <div className="Herramientas11">
        <div className="Herramientas111">{study.getPatientName()}</div>
        <div className="Herramientas112">
          <IconoHerramientas icon="Share" onClick={abrirDialog.bind(this, 0)} />
          <IconoHerramientas
            icon="upload"
            onClick={abrirDialog.bind(this, 1)}
          />
          <IconoHerramientas
            icon="broadcast"
            onClick={abrirDialog.bind(this, 2)}
          />
          <IconoHerramientas icon="download" onClick={DownloadStudy} />
        </div>
      </div>
      <div className="Herramientas12" onClick={cerrarherramientas}>
        <img src={cerrar} alt="" width="40px" />
      </div>
    </div>
  );
};

/**
 * @param {Object} props
 * @param {string} props.icon
 * @param {function(): void} props.onClick
 * @returns {JSX.Element}
 */
const IconoHerramientas = (props) => {
  const icon = props.icon;
  switch (icon) {
    case "Share":
      return (
        <div className="IconoHerramientas" onClick={props.onClick}>
          <Share2 size={40} />
        </div>
      );
    case "upload":
      return (
        <div className="IconoHerramientas" onClick={props.onClick}>
          <Paperclip size={40} />
        </div>
      );
    case "broadcast":
      return (
        <div className="IconoHerramientas" onClick={props.onClick}>
          <BookUser size={40} />
        </div>
      );
    case "download":
      return (
        <div className="IconoHerramientas" onClick={props.onClick}>
          <CloudDownload size={40} />
        </div>
      );
    default:
      return (
        <div className="IconoHerramientas" onClick={props.onClick}>
          <Share2 size={40} />
        </div>
      );
  }
};
///////////////////////////////////////
const Cargando = () => {
  return (
    <div className="CargandoContenedor">
      <Loader2 className="LoaderIcon" size={60} />
      <span>Cargando estudios...</span>
    </div>
  );
};

const ErrorServidor = () => {
  const { syncLista } = useMainContext();
  return (
    <div className="ErrorContenedor">
      <div className="ErrorIconoBg">
        <ServerCrash className="ErrorIcon" size={70} strokeWidth={1.5} />
      </div>
      <h2 className="ErrorTitulo">Error de conexión</h2>
      <p className="ErrorDescripcion">
        No pudimos establecer conexión con el servidor. Por favor, revisa tu
        conexión a internet o inténtalo de nuevo más tarde.
      </p>
      <button className="BtnReintentar" onClick={syncLista}>
        Reintentar conexión
      </button>
    </div>
  );
};

const SinResultados = () => {
  return (
    <div className="ErrorContenedor">
      <div
        className="ErrorIconoBg"
        style={{
          backgroundColor: "#f8f9fa",
          color: "#6c757d",
          boxShadow: "none",
          animation: "none",
        }}
      >
        <SearchX className="ErrorIcon" size={70} strokeWidth={1.5} />
      </div>
      <h2 className="ErrorTitulo">No hay estudios</h2>
      <p className="ErrorDescripcion">No se encontraron estudios.</p>
    </div>
  );
};
